import type { IUserForm } from "@/types"
import { useMutation } from "@tanstack/vue-query"
import { axios } from "@/axios"
import { User } from "@/models"

interface IUseUpdateUserArgs {
  user: IUserForm
}

export async function updateUser(user: IUserForm) {
  const response = await axios.patchForm(`api/user`, user)

  return response.data?.Data ? User.fromResponse(response.data.Data) : null
}

export function useUpdateUser() {
  return useMutation({
    mutationKey: ["updateUser"],
    mutationFn: ({ user }: IUseUpdateUserArgs) => updateUser(user),
  })
}
